
import React from 'react';
import ReactDOM from 'react-dom';

import ResponseMessages from '../../components/ResponseMessages/ResponseMessages';

class ErrorBoundary extends React.Component{

  constructor( props ){
    super( props );
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError( error ){
    return { hasError: true };
  }

  componentDidCatch( error, errorInfo ){
    console.log( error ); // eslint-disable-line
    this.setState( {
      error,
      errorInfo
    } )
  }

  render(){
    if( this.state.errorInfo ){
      return (
        <>
          <ResponseMessages
            messageType='error'
            message={ this.state.error?.toString() }
          />
        </>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary;
